import React, { useState, useRef, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SimpleReactValidator from "simple-react-validator";

function ChangePassword() {
    const [userName, setUsername] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [passError, setPassError] = useState(false);
    const [code, setCode] = useState("");
    const [, forceUpdate] = useState();
    const validator = useRef(new SimpleReactValidator({
        messages: {
            email: 'Please enter a valid username.'
        },
        autoForceUpdate: { forceUpdate }
    }));

    const handleSubmit = () => {
        if (!validator.current.allValid()) {
            setIsSubmit(false);
            validator.current.showMessages();
            forceUpdate(1);
            return false;
        }
        if (!pass_reg.test(newPassword)) {
            return setPassError(true);
        }
        const request = new Request(`https://vr-api.azurewebsites.net/api/User/ChangePassword`, {
            method: 'POST',
            headers: new Headers({ 'Content-Type': 'application/json' }),
            body: JSON.stringify({ userName, newPassword, code })
        });
        fetch(request).then(res => {
            return res.status;
        }).then(status => {
            if (status === 200) {
                toast.success("Password reset successfully completed.", {
                    position: toast.POSITION.TOP_LEFT
                });
                setUsername("");
                setNewPassword("");
                setCode("");
                window.location.href = "/";
            } else {
                toast.error("Unable to set password, please try again.", {
                    position: toast.POSITION.TOP_LEFT
                });
            }


        }).catch(err => {
            console.log('%c Err', 'font-size:20px;color:red', err);
        })
    };

    useEffect(() => {
        if (pass_reg.test(newPassword)) {
            setPassError(false);
        }
    }, [newPassword])

    return (
        <section className="login_bg reset-pass">
            <ToastContainer />
            <div className="container">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-lg-4 col-md-3 col-sm-3 col-xs-12"></div>
                        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                            <div className="login_block">
                                <div className="login_about">
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 col-sm-12">
                                        <div className="form_login">
                                            <div className="form-group">
                                                <div className="col-md-12 text-center">
                                                    <img src="../../../images/logo.png" style={{ width: '120px' }} className="center-block" alt="..." />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="col-md-12 text-center">
                                                    <h3>Change Password</h3>
                                                </div>
                                            </div>
                                            <form>
                                                <div className="form-group">
                                                    <div className="col-sm-12">
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-addon"  >
                                                                <i className="fa fa-user"></i>
                                                            </div>
                                                            <input type="text" className="form-control"
                                                                value={userName}
                                                                name="userName"
                                                                onChange={e => setUsername(e.target.value)}
                                                                placeholder="Username" />
                                                            <i className="fa fa-question-circle help_icon" data-toggle="tooltip" title="Use your email address" ></i>
                                                        </div>
                                                        {validator.current.message("Username", userName, `required|email`)}
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-sm-12">
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-addon">
                                                                <i className="fa fa-lock"></i>
                                                            </div>
                                                            <input type="password" name="newPassword" onChange={e => setNewPassword(e.target.value)} value={newPassword} className="form-control" placeholder="Password" />
                                                            <a href="javascript:void(0)" data-toggle="tooltip" title="New account password &#013; The password must be at least 8 characters long, contain 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character" ><i className="fa fa-question-circle help_icon"></i></a>
                                                        </div>
                                                        {validator.current.message("Password", newPassword, "required")}
                                                        {passError && !newPassword ? <div className='srv-validation-message'>
                                                            Please enter a valid password
                                                        </div> : null}
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-sm-12">
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-addon"  >
                                                                <i className="fa fa-user"></i>
                                                            </div>
                                                            <input type="text" className="form-control"
                                                                value={code}
                                                                name="code"
                                                                onChange={(e) => setCode(e.target.value)}
                                                                placeholder="Code" />
                                                            <i className="fa fa-question-circle help_icon" data-toggle="tooltip" title="Use otp code received on your email address" ></i>
                                                        </div>
                                                        {validator.current.message("Code", code, "required")}
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-sm-12 text-right">
                                                                <button type="button" onClick={handleSubmit} className="btn btn-primary btn-sm">Change Password</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-sm-12">
                                                                <a href="/" >Back To Sign in</a>
                                                            </div>
                                                            {/* <div className="col-sm-6">
                                                    <label>Can't access email</label>
                                                </div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-3 col-sm-3 col-xs-12"></div>
                    </div>
                </div>
            </div>
        </section >
    )
}

export default ChangePassword